import {useNavigate, useSearchParams} from "react-router-dom";
import {rrcEp10WasteManifestSelector, useGetRrcEp10WasteManifestByKeyQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";
import {
  RrcEp10WasteManifestKeyProfile
} from "../../components/profile/RrcEp10WasteManifestProfile/RrcEp10WasteManifestKeyProfile";

type Props = {
  manifestNumber?: string
  tenantCode?: string;
}

export const RrcEp10WasteManifestKeyProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const manifestNumber = params.get("manifestNumber") ?? undefined;
  const tenantCode = params.get("tenantCode") ?? undefined;

  if (!manifestNumber) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.rrcep10wastemanifest", "RRC EP-10 Waste Manifest") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <RrcEp10WasteManifestKeyProfilePage manifestNumber={manifestNumber} tenantCode={tenantCode}/>;
};

export const RrcEp10WasteManifestKeyProfilePage = (props: Props) => {
  const {manifestNumber, tenantCode} = props;

  const selectRrcEp10WasteManifest = useMemo(() => {
    return rrcEp10WasteManifestSelector()
  }, []);

  const {rrcEp10WasteManifest, isFetching} = useGetRrcEp10WasteManifestByKeyQuery(manifestNumber ? {
    manifestNumber: manifestNumber,
    tenantCode: tenantCode
  } : skipToken, {
    selectFromResult: (result) => ({
      rrcEp10WasteManifest: selectRrcEp10WasteManifest(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage
      entity={rrcEp10WasteManifest}
      isLoading={isFetching}
      permissions={["rrcep10wastemanifest_view"]}
    >
      {(entity) => (
        <RrcEp10WasteManifestKeyProfile rrcEp10WasteManifest={entity}/>
      )}
    </EntityProfilePage>
  )
};
